import { render } from "./FivePoint.vue?vue&type=template&id=637f0a32&scoped=true&ts=true"
import script from "./FivePoint.vue?vue&type=script&lang=ts"
export * from "./FivePoint.vue?vue&type=script&lang=ts"

import "./FivePoint.vue?vue&type=style&index=0&id=637f0a32&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f0a32"]])

export default __exports__